import {capitalize, FormControlLabel, MenuItem} from "@mui/material";
import {FastField, Field, useFormikContext} from "formik";
import {Select, Switch} from 'formik-mui';
import {useUnteraufgabenHandling} from "../../hooks/unteraufgaben/useUnteraufgabenHandling";
import {Unteraufgabe} from "../../api";
import Grid from "@mui/material/Grid2";
import {AntwortTyp} from "../../models/Antworttypen";

interface AbortCriterionFieldsProps {
    reihenfolge: number;
    canEditFields: boolean;
    variant: 'toggle' | 'field';
}

export default function AbortCriterionFields({
    reihenfolge,
    canEditFields,
    variant
}: AbortCriterionFieldsProps) {
    const { translation } = useUnteraufgabenHandling();
    const { values, setFieldValue } = useFormikContext<{ unteraufgaben: Unteraufgabe[] }>();

    const currentUnteraufgabe = values.unteraufgaben[reihenfolge];
    const isAnswerTypeBoolean = currentUnteraufgabe?.antworttyp === AntwortTyp.BOOLEAN;
    const hasAbortCriterion = currentUnteraufgabe?.noRescheduleOnResponseValue !== null &&
                              currentUnteraufgabe?.noRescheduleOnResponseValue !== undefined;

    if (!isAnswerTypeBoolean) {
        return null;
    }

    if (variant === 'toggle') {
        return (
            <FormControlLabel
                control={
                    <Field
                        component={Switch}
                        type="checkbox"
                        name={`unteraufgaben.${reihenfolge}.noRescheduleOnResponseValue`}
                        checked={hasAbortCriterion}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            if (e.target.checked) {
                                // Enable abort criterion with default value true
                                setFieldValue(`unteraufgaben.${reihenfolge}.noRescheduleOnResponseValue`, true);
                            } else {
                                // Disable abort criterion
                                setFieldValue(`unteraufgaben.${reihenfolge}.noRescheduleOnResponseValue`, null);
                            }
                        }}
                        disabled={!canEditFields}
                    />
                }
                label={capitalize(translation("abort-criterion"))}
                labelPlacement="end"
            />
        );
    }

    // variant === 'field'
    if (!hasAbortCriterion) {
        return null;
    }

    return (
        <Grid size={3}>
            <FastField
                id={`unteraufgaben.${reihenfolge}.noRescheduleOnResponseValue`}
                name={`unteraufgaben.${reihenfolge}.noRescheduleOnResponseValue`}
                component={Select}
                label={capitalize(translation("abort-on-answer"))}
                disabled={!canEditFields}
                fullWidth
            >
                <MenuItem value={true as any}>{capitalize(translation("boolean-true"))}</MenuItem>
                <MenuItem value={false as any}>{capitalize(translation("boolean-false"))}</MenuItem>
            </FastField>
        </Grid>
    );
}

